import * as ActivityCBCTeaching from './activityCBCTeaching.js';
export default ActivityCBCTeaching;
